import React, { useState } from 'react';

import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';

import ActionLink from 'components/buttons/ActionLink';
import UnsavedChangesModal from 'components/projectForm/UnsavedChangesModal';

export default function SequenceOfOperationsFooter({
  anyUnsaved,
  isReviewing,
  projectId,
}) {
  const [action, setAction] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectForm.SequenceOfOperationsFooter',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  // find a better way to do this!
  const actionButton = () => {
    switch (action) {
      case i18nTShared('next'):
        return (
          <ActionLink
            disableAfterClick={true}
            linkText={i18nT('actionLink.text')}
            styleClasses='tw-apply-filled-button tw-apply-filled-button--md tw-apply-filled-button--red tw-apply-filled-button--on-light'
            url={`method${isReviewing ? '?review=true' : ''}`}
          />
        );
      case i18nTShared('previous'):
        return (
          <ActionLink
            disableAfterClick={true}
            linkText={i18nT('actionLink.text')}
            styleClasses='tw-apply-filled-button tw-apply-filled-button--md tw-apply-filled-button--red tw-apply-filled-button--on-light'
            url={`risk_assessment?previous=true${isReviewing ? '&review=true' : ''}`}
          />
        );
      case i18nTShared('saveAndExit'):
        return (
          <ActionLink
            dataMethod='put'
            disableAfterClick={true}
            linkText={i18nT('actionLink.text')}
            rel='no-follow'
            styleClasses='tw-apply-filled-button tw-apply-filled-button--md tw-apply-filled-button--red tw-apply-filled-button--on-light'
            url={`/projects/${projectId}?save=true${isReviewing ? '&review=true' : ''}`}
          />
        );
    }
  };

  const openModal = (action) => {
    setAction(action);
    setIsModalOpen(true);
  };

  return (
    <>
      <PortaledActionButtons direction='left'>
        <ActionLink
          disableAfterClick={true}
          linkText={i18nTShared('previous')}
          openUnsavedChangesModal={openModal}
          performCheck={anyUnsaved}
          styleClasses='tw-apply-outlined-button tw-apply-outlined-button--md tw-apply-outlined-button--blue-grey tw-apply-outlined-button--on-dark nav-button'
          url={`risk_assessment?previous=true${isReviewing ? '&review=true' : ''}`}
        />
      </PortaledActionButtons>
      <PortaledActionButtons direction='right'>
        <ActionLink
          disableAfterClick={true}
          linkText={i18nTShared('next')}
          openUnsavedChangesModal={openModal}
          performCheck={anyUnsaved}
          styleClasses='tw-apply-outlined-button tw-apply-outlined-button--md tw-apply-outlined-button--blue-grey tw-apply-outlined-button--on-dark nav-button tw-mr-3'
          url={`method${isReviewing ? '?review=true' : ''}`}
        />
        <ActionLink
          dataMethod='put'
          disableAfterClick={true}
          linkText={i18nTShared('saveAndExit')}
          openUnsavedChangesModal={openModal}
          performCheck={anyUnsaved}
          rel='no-follow'
          styleClasses='tw-apply-filled-button tw-apply-filled-button--md tw-apply-filled-button--mint tw-apply-filled-button--on-dark nav-button'
          url={`/projects/${projectId}?save=true${isReviewing ? '&review=true' : ''}`}
        />
      </PortaledActionButtons>
      {anyUnsaved && isModalOpen && (
        <UnsavedChangesModal
          actionButton={actionButton()}
          body={<p>{i18nT('unsavedChanges.body')}</p>}
          header={<strong>{i18nT('unsavedChanges.header')}</strong>}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
}

const PortaledActionButtons = ({ children, direction }) => {
  const buttonLocation = document.getElementsByClassName(
    `project-actions-${direction}`,
  );

  return ReactDOM.createPortal(children, buttonLocation[0]);
};
